import { useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import API, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Check } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Las contraseñas no coinciden"); return; }
    if (password.length < 6) { setError("Mínimo 6 caracteres"); return; }
    setError("");
    setLoading(true);
    try {
      await API.post("/auth/reset-password", { token, new_password: password });
      setSuccess(true);
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] px-4">
      <div className="text-center">
        <p className="text-sm text-[#475569]">Token inválido.</p>
        <Link to="/login" className="text-sm text-[#0047AB] hover:underline mt-2 inline-block">Volver al login</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] px-4" data-testid="reset-password-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-[#0F172A]" style={{ fontFamily: 'Chivo' }}>Nueva Contraseña</h1>
        </div>
        <div className="bg-white border border-[#E2E8F0] rounded-sm p-6">
          {success ? (
            <div className="text-center py-4">
              <Check className="w-8 h-8 text-green-600 mx-auto mb-2" />
              <p className="text-sm font-medium text-[#0F172A]">Contraseña actualizada</p>
              <p className="text-xs text-[#475569] mt-1">Redirigiendo al login...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && <p className="text-sm text-red-600">{error}</p>}
              <div>
                <Label className="text-sm font-medium text-[#0F172A]">Nueva contraseña</Label>
                <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Mínimo 6 caracteres" className="mt-1 border-[#CBD5E1] rounded-sm" data-testid="new-password-input" />
              </div>
              <div>
                <Label className="text-sm font-medium text-[#0F172A]">Confirmar contraseña</Label>
                <Input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required placeholder="Repetir contraseña" className="mt-1 border-[#CBD5E1] rounded-sm" data-testid="confirm-password-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-[#E30613] text-white font-bold rounded-sm py-2.5 hover:bg-[#C80410]" data-testid="reset-submit-btn">
                {loading ? "Actualizando..." : "Cambiar Contraseña"}
              </Button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
